import { render } from "./SuccessPayment.vue?vue&type=template&id=74943b52"
import script from "./SuccessPayment.vue?vue&type=script&lang=js"
export * from "./SuccessPayment.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__